/**
 * Created by alex.y on 8/8/2017.
 */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Order } from "../../objects/orders/order";
import { OrderService } from "../../services/orderService";
import { CanadianCurrencyCode } from "../../objects/currencyExchange/canadianCurrencyCode";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { OrderTotal } from "../../objects/orders/orderTotal";
import { CalculatorType } from "../../objects/orders/calculatorType";
import { CalculatorHelper } from "../../common/helpers/calculatorHelper";
import { FillOrderTabComponent } from "./tabs/fill-order-tab/fill-order-tab.component";
import { ExtraDataService } from "../../services/extraDataService";
import { ExtraData } from "../../objects/extraData/extraData";
import { OrderStatus } from "../../objects/orders/orderStatus";
import { ItemTax, OrderItem } from "../../objects/orders/orderItem";
import { Customer } from "../../objects/customers/customer";
import { OrderDataComponent } from "../Managment/orderManagement/orderData/orderData.component";
import { OrderOptions } from "../../objects/orders/orderOptions";
import { CalculatorTabComponent } from "./tabs/calculator-tab/calculatorTab.component";
import { TabDirective } from "ngx-wizard";
import { WizardComponent } from "ngx-wizard";
import { HScodeHelper } from "../../common/helpers/HScodeHelper";
import { TaxType } from "../../objects/orders/taxType";
import { AgentModalComponent } from "../agent/modal/agent-modal.component";
import { AaFeeChangeModalComponent } from "./modals/aafee-change-modal.component";
import { OrderHelper } from "../../common/helpers/orderHelper";
import { TaxHelper } from "../../common/helpers/tax.helper";
import { ViewType } from "../../objects/users/viewType";
import { ScreenHelper } from "../../common/helpers/screenHelper";
import { UUID } from 'angular2-uuid';
import { PublisherService } from "../../services/publisher.service";


@Component({
    selector: "calculator",
    templateUrl: "./calculator.component.html",
    moduleId: module.id.toString()
})
export class CalculatorComponent implements OnInit {

    @Input()
    public order: Order = new Order();

    @Input()
    public extraData: ExtraData = new ExtraData();

    @Output()
    public orderChange: EventEmitter<Order> = new EventEmitter();

    @Output()
    public tabChanged: EventEmitter<number> = new EventEmitter();

    @Input()
    public isOrderDetails: boolean = false;

    @Input()
    public isPublic: boolean = false;

    @Input() mainElement: ElementRef;

    public isProcessing: boolean = true;

    public canadianCurrencyCodes: CanadianCurrencyCode[] = [];

    @ViewChild('fillOrder')
    public fillOrderTab: FillOrderTabComponent;

    @ViewChild('calculatorWizard')
    public calculatorWizard: WizardComponent;

    @ViewChild(TabDirective) public tabDirective: TabDirective;

    @ViewChild(OrderDataComponent) public orderDataComponent: OrderDataComponent;

    @ViewChild('orderDataTab') public orderDataTab: TabDirective;

    @ViewChild(CalculatorTabComponent) public calculatorTabComponent: CalculatorTabComponent;
    @ViewChild('aaChangeModal') aaChangeModal: AaFeeChangeModalComponent;

    public firstAttempt: boolean = false;
    public orderStatus = OrderStatus;
    public calculatorHelper = CalculatorHelper;

    public stringLink = String;
    public query: string = "";
    public viewTypeEnum: ViewType;
    public viewType: string;

    public hideQuote: boolean = false;
    public isFirstTabOpened: boolean = false;

    private validateFrom: boolean = true;

    public get disableChanges(): boolean {
        if (this.order.Status >= OrderStatus.Paid || (this.isPublic && this.order.Status >= OrderStatus.Quoted)) {
            return true;
        }

        return false;
    }

    public clonedOrder: Order = new Order();

    public sendCustomer: boolean = true;

    public isModalChnageShown: boolean = false;

    public constructor(public orderService: OrderService, private route: ActivatedRoute, private extraDataService: ExtraDataService, public router: Router,
                       private publisherService: PublisherService) {

    }

    ngOnInit(): void {
        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;

        this.viewTypeEnum = ScreenHelper.getViewType();
        this.viewType = ViewType[this.viewTypeEnum];

        if (!this.router.url.includes('calculator/agent'))
            this.hideQuote = true;

        this.order.Source = "Agent Calculator";

        if (this.router.url == '/calculator/public') {
            this.order.Flag |= OrderOptions.IsPulic;
            this.order.Source = "Public Calculator";
        }

        if (this.router.url == '/calculator2/public') {
            this.order.Source = "Public Calculator";
        }

        this.clonedOrder = JSON.parse(JSON.stringify(this.order));

        if (this.order.Id) {
            this.firstAttempt = true;
            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            if (this.order.Status == OrderStatus.Calculated || this.order.Status == OrderStatus.Quoted) {

                this.isProcessing = true;

                this.orderService.modify(this.order).then(x => {
                    this.isProcessing = false;

                    if (!x || !x.Data)
                        return;

                    this.order = x.Data;
                    this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
                    this.orderChange.emit(this.order);

                    setTimeout(() => {
                        if (this.calculatorTabComponent && OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited))
                            this.calculatorTabComponent.recalculateTaxesToSelected(this.order);
                        this.calculatorTabComponent.recalculateTotals();
                    })

                });
            }
        }
    }

    public checkFillOrderForm(event: any): void {
        if (!this.validateFrom) {
            this.validateFrom = true;
            return;
        }

        if (!this.firstAttempt && !this.fillOrderTab.checkForm())
            event.preventDefault();
    }

    public calculateOrder(event: any): void {
        if (this.firstAttempt || this.disableChanges) {
            this.isProcessing = false;

            if (this.mainElement)
                this.mainElement.nativeElement.scrollTop = 0;

            return;
        }

        this.isFirstTabOpened = false;

        this.isProcessing = true;

        if (this.order.CalculatorType == CalculatorType.UsaImport) {
            this.order.Currency = this.canadianCurrencyCodes.find(x => x.Name == 'USD');
        } else {
            this.order.Currency = this.canadianCurrencyCodes.find(x => x.Name == 'CAD');
        }

        this.order.OrderItems.forEach(item => {
            item.Product.HsCode = HScodeHelper.addDotAfterLastTwoNumb(item.Product.HsCode);
        });

        if (OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited)) {
            this.moveTaxes();

            if (this.calculatorTabComponent)
                this.calculatorTabComponent.recalculateTaxes(this.order);
        }

        const requestId = UUID.UUID();
        const isNewOrder = this.order.Id === null || this.order.Id === undefined;

        if (isNewOrder) {
            this.publisherService
                .bbPublisherRequest(requestId, this.order)
                .subscribe();
        }

        this.orderService.create(this.order, this.viewType).then(response => {

            if (!response || !response.Data) {
                this.isProcessing = false;
                throw new Error("Extra data was not created");
            }

            if (isNewOrder) {
                this.publisherService
                    .bbPublisherRequest(requestId, {'quote_id': response.Data.Id})
                    .subscribe();
            }

            this.saveExtraData(response.Data.Customer.Id);

            if (!this.clonedOrder.Id)
                this.clonedOrder = JSON.parse(JSON.stringify(response.Data));
            else
                this.addItemsToClonedOrder(response.Data);
            this.sendCustomer = false;
            this.order = response.Data;
            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            this.orderChange.emit(this.order);

            this.isProcessing = false;

            setTimeout(x => {
                this.sendCustomer = true;
            }, 1250);

            if (this.orderDataComponent)
                this.orderDataComponent.selectTab(1);

            if (this.mainElement)
                this.mainElement.nativeElement.scrollTop = 0;
        });
    }

    private moveTaxes(): void {
        if (this.order.OrderItems.length == this.clonedOrder.OrderItems.length) {

            for (let i = 0; i < this.order.OrderItems.length; i++) {
                const currentAATax = TaxHelper.getItemTaxOrNull(this.order.OrderItems[i], TaxType.AAFee);

                const previousAATax = TaxHelper.getItemTaxOrNull(this.clonedOrder.OrderItems[i], TaxType.AAFee);

                if (currentAATax == null) {
                    this.order.OrderItems[i].Taxes.push(new ItemTax({
                        Value: previousAATax.Value,
                        TaxType: TaxType.AAFee
                    }));
                    continue;
                }

                currentAATax.Value = previousAATax.Value;
            }

            return;
        }

        let total = 0;

        this.clonedOrder.OrderItems.forEach(orderItem => {
            const previousAATax = TaxHelper.getItemTaxOrNull(orderItem, TaxType.AAFee);

            total += previousAATax.Value;
        });

        this.order.OrderItems.forEach(orderItem => {
            const aaTax = TaxHelper.getItemTaxOrNull(orderItem, TaxType.AAFee);

            if (aaTax == null) {
                orderItem.Taxes.push(new ItemTax({
                    Value: 0,
                    TaxType: TaxType.AAFee
                }));
            }
        });

        this.order = TaxHelper.convertTotalToTaxes(total, this.order);

        // get Total and then apply it to all order items
    }

    private addItemsToClonedOrder(order: Order): void {
        // if(this.clonedOrder.OrderItems.length < order.OrderItems.length){
        //     for(let i = 0; i < order.OrderItems.length - this.clonedOrder.OrderItems.length; i++){
        //         this.clonedOrder.OrderItems.push(new OrderItem());
        //     }
        // }

        let orderItems: Array<OrderItem> = new Array<OrderItem>();

        for (let orderItem of order.OrderItems) {
            let foundItem = this.clonedOrder.OrderItems.find(x => x.Id == orderItem.Id);

            if (foundItem != null)
                orderItems.push(foundItem);
            else
                orderItems.push(orderItem);
        }

        this.clonedOrder.OrderItems = JSON.parse(JSON.stringify(orderItems));
    }

    public saveExtraData(customerId: number): void {
        this.extraData.ReferenceId = customerId ? customerId.toString() : null;
        this.extraData.ReferenceType = 0;
        this.extraData.Name = "marketing text";

        this.extraDataService.modify(this.extraData).then();
    }

    public createEvent(): void {
        this.order = new Order();
        this.order.Source = "Agent Calculator";
        if (this.router.url == '/calculator/public' || this.router.url == '/calculator2/public')
            this.order.Source = "Public Calculator";
        this.order.OrderItems = [new OrderItem()];
        this.extraData = new ExtraData();
        this.fillOrderTab.resetForm();
        // this.validateFrom = false;
        if (!this.tabDirective.active)
            this.tabDirective.active = true;

        if (this.isOrderDetails)
            this.router.navigate(['/calculator/agent']);
    }

    public goToSearch(): void {
        this.router.navigate(['/management/order', { query: this.query }])
    }

    public setOrderDataTab(num: number): void {
        if (!this.tabDirective.active)
            this.tabDirective.active = true;

        this.calculatorWizard.tabs[2].active = true;

        this.orderDataComponent.selectTab(num);
    }

    public cloneOrder(): void {
        this.clonedOrder = JSON.parse(JSON.stringify(this.order));
        this.isProcessing = false;
    }

    public showModal(event: any): void {
        if (this.isModalChnageShown == true) {
            this.isModalChnageShown = false;
            return;
        }

        if (this.order.Status >= OrderStatus.Paid) {
            this.isProcessing = false;
            return;
        }

        if (!this.isFirstTabOpened)
            return;

        if (!OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited)) {
            this.calculateOrder(null);
            return;
        }

        this.isModalChnageShown = true;

        event.preventDefault();

        this.aaChangeModal.show();
    }

    public onFistTabSelected(): void {
        this.isProcessing = true;
        this.firstAttempt = false;
        this.cloneOrder();
        this.isModalChnageShown = false;
        this.isFirstTabOpened = true;
    }

    public modalHiddenHandler(event: any): void {
        if (this.isFirstTabOpened)
            this.calculatorWizard.nextTab(false);
        else {
            this.calculatorWizard.previousTab(false);
        }

        this.firstAttempt = false;

        if (this.disableChanges)
            return;

        this.calculateOrder(event)
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/calculator.component.ts